import { Alert } from 'models';
import { Action, Notification } from 'models/forms';
import {
  ADD_PROGRAM_SUCCESS,
  UPDATE_PROGRAM_SUCCESS,
  REMOVE_PROGRAM_SUCCESS,
  ADD_PROGRAM_FAIL,
  REMOVE_PROGRAM_FAIL,
  ADD_MESSAGE_SUCCESS,
  UPDATE_MESSAGE_SUCCESS,
  REMOVE_MESSAGE_SUCCESS,
  ADD_MESSAGE_FAIL,
  UPDATE_MESSAGE_FAIL,
  REMOVE_MESSAGE_FAIL,
} from 'constants/notifications';

export const getProgramsFormNotification = (
  success: boolean,
  action: Action,
): Notification => {
  let message = '';
  let status = Alert.SUCCESS;
  if (success) {
    switch (action) {
      case Action.ADD:
        message = ADD_PROGRAM_SUCCESS;
        break;
      case Action.UPDATE:
        message = UPDATE_PROGRAM_SUCCESS;
        break;
      case Action.REMOVE:
        message = REMOVE_PROGRAM_SUCCESS;
        break;

      default:
        break;
    }
  } else {
    status = Alert.ERROR;
    switch (action) {
      case Action.ADD:
        message = ADD_PROGRAM_FAIL;
        break;
      case Action.UPDATE:
        message = UPDATE_PROGRAM_SUCCESS;
        break;
      case Action.REMOVE:
        message = REMOVE_PROGRAM_FAIL;
        break;

      default:
        break;
    }
  }
  return { status, message };
};

export const getMessagesFormNotification = (
  success: boolean,
  action: Action,
): Notification => {
  let message = '';
  let status = Alert.SUCCESS;
  if (success) {
    switch (action) {
      case Action.ADD:
        message = ADD_MESSAGE_SUCCESS;
        break;
      case Action.UPDATE:
        message = UPDATE_MESSAGE_SUCCESS;
        break;
      case Action.REMOVE:
        message = REMOVE_MESSAGE_SUCCESS;
        break;

      default:
        break;
    }
  } else {
    status = Alert.ERROR;
    switch (action) {
      case Action.ADD:
        message = ADD_MESSAGE_FAIL;
        break;
      case Action.UPDATE:
        message = UPDATE_MESSAGE_FAIL;
        break;
      case Action.REMOVE:
        message = REMOVE_MESSAGE_FAIL;
        break;

      default:
        break;
    }
  }
  return { status, message };
};
